import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, useMemo, createContext, useContext } from 'react';
import { Box } from '../Box/index.js';

/* ======================================= */
/**
 * Context is used to pass form states and meta data to InputGroup children
 */
const InputGroupContext = /*#__PURE__*/createContext({});
const useInputGroupContext = () => useContext(InputGroupContext);
/* ======================================= */
/**
 * InputGroup provides context such as `isInvalid`, `isDisabled`, and `isRequired` to form elements.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/input-group#usage)
 * - [Props](https://blockparty.endpoint.com/components/input-group#props)
 * <br />
 *
 */
const InputGroup = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    isInvalid,
    isRequired,
    isDisabled,
    isReadOnly,
    groupId,
    ...rest
  } = _ref;
  const context = useMemo(() => ({
    isRequired,
    isDisabled,
    isInvalid,
    isReadOnly,
    groupId
  }), [isRequired, isDisabled, isInvalid, isReadOnly, groupId]);
  return /*#__PURE__*/React__default.createElement(InputGroupContext.Provider, {
    value: context
  }, /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    position: "relative",
    role: "group"
  }, rest), children));
});

export { InputGroup, useInputGroupContext };
